import { render, staticRenderFns } from "./Contact-Form.vue?vue&type=template&id=d623bd50&scoped=true&"
import script from "./Contact-Form.vue?vue&type=script&lang=js&"
export * from "./Contact-Form.vue?vue&type=script&lang=js&"
import style0 from "./Contact-Form.vue?vue&type=style&index=0&id=d623bd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d623bd50",
  null
  
)

export default component.exports